import { SHA256 } from 'crypto-js';
import { getCurrentUserEmail } from './auth/authenticatedUser';

const deviceId = 'web';

const hashEmail = (email) => SHA256(email).toString();

const envelope = async ({
  miningId, _type, clientId, data, inviteId, agreements,
}) => ({
  inviteId,
  deviceId,
  uuid: miningId,
  source: 'Mobile',
  _type,
  version: 'v3',
  clientId,
  data: {
    ...data,
    source: 'Mobile',
    timestamp: new Date().toISOString(),
    messageId: miningId,
    clientId,
    userId: hashEmail(await getCurrentUserEmail()),
    deviceId,
    _type,
    agreements,
  },
});

export const forDeviceData = async (args, agreements) => envelope({
  ...args,
  _type: args.type,
  agreements,
  data: {
    ...args,
  },
});

export const forSocialData = async (args, agreements) => envelope({
  ...args,
  _type: 'ts-extractors',
  agreements,
  data: {
    data: {
      idToken: args.idToken,
      clientId: args.clientId,
      messageId: args.miningId,
      userId: hashEmail(await getCurrentUserEmail()),
      source: 'Mobile',
      timestamp: new Date().toISOString(),
      type: args.type,
    },
  },
});
